import { compose } from "recompose";
import { connect } from "react-redux";
import React, { Component } from "react";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";
import DefaultGroup from "./DefaultGroup";
import CommandsGroup from "./CommandsGroup";
import ScrollBox from "src/atoms/ScrollBox/index";
import environment from "src/utils/environment";
// import { getRemoteConfigValue } from "src/modules/firebase/index";
import withColorMode from "src/styling/withColorMode";
// import { store } from "src/store/store";
// import { getIsInDetachMode } from "src/duck/selectors";

// const FIVE_SECONDS = 5000;

class ControlButtons extends Component {
  state = {
    openedGroup: "default", // [default, commands]
    animating: false
  };
  groupsWrapperRef = React.createRef();
  freemiumVideoStartDate = null;
  timeoutId = null;
  // videoDuration = getRemoteConfigValue("freemium_video_time");

  componentWillUnmount() {
    cancelAnimationFrame(this.requestFrameId);
  }

  openCommandsGroup = () => {
    this.setState({ animating: true, openedGroup: "commands" });
    clearInterval(this.requestFrameId);
    this.requestFrameId = requestAnimationFrame(() => {
      this.setState({ animating: false });
    });
  };
  closeGroup = () => {
    this.setState({ animating: true, openedGroup: "default" });
    clearInterval(this.requestFrameId);
    this.requestFrameId = requestAnimationFrame(() => {
      this.setState({ animating: false });
    });
  };
  scrollToBottom = () => {
    const wrapper = this.groupsWrapperRef.current;
    wrapper.scrollTo({
      top: wrapper.scrollHeight - wrapper.clientHeight
    });
  };

  render() {
    const { animating, openedGroup } = this.state;
    const { parentStation, colorMode, isFreeVersion, closeCameraList } =
      this.props;
    const { primaryStation } = parentStation;
    const { activity } = primaryStation;

    const isDarkMode = colorMode === "dark";
    return (
      <ScrollBox
        reference={this.groupsWrapperRef}
        pr="12px"
        pl="16px"
        maxHeight="calc(100vh - 14px - 90px)"
        position="absolute"
        bottom={environment.isBibino ? "2px" : "14px"}
        right="4px"
      >
        <DefaultGroup
          in={openedGroup === "default" && !animating}
          isDarkMode={isDarkMode}
          openCommandsGroup={this.openCommandsGroup}
          parentStation={parentStation}
          isFreeVersion={isFreeVersion}
          closeCameraList={closeCameraList}
        />
        <CommandsGroup
          in={openedGroup === "commands" && !animating}
          closeGroup={this.closeGroup}
          activity={activity}
          isDarkMode={isDarkMode}
          parentStation={parentStation}
          scrollToBottom={this.scrollToBottom}
        />
      </ScrollBox>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFreeVersion: isFreemium(state)
  };
}

const enhance = compose(
  connect(mapStateToProps),
  withColorMode,
  withParentStation
);
export default enhance(ControlButtons);
